/*eslint-disable */
define(function(require) {
    var $ =  require('jquery');
    var URI = require('URIjs/URI');

    var $popup;

    function closePopup() {
        $popup.popup('close');
    }

    return function(accountLocked) {
        var $page = $.mobile.pageContainer.pagecontainer('getActivePage');
        $popup = $("#password-reset-required-popup-" + $page.attr("id"));
        var $passwordResetText = $popup.find('.password-reset-text');
        var $accountLockedText = $popup.find('.account-locked-text');

        $passwordResetText.toggle(!accountLocked);
        $accountLockedText.toggle(accountLocked);

        $page.find('.close a').on('click', closePopup);
        $popup.popup('open');
    };
});
